import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Odometer from 'react-odometerjs';
import 'odometer/themes/odometer-theme-default.css';
import displayUnit from '../../../../../../../utils/displayUnit';

export const formatOdometer = (reading, language, decimalPlacesCount = 3) => {
  const isFloat = reading % 1 !== 0;
  const dString = 'd'.repeat(decimalPlacesCount);

  if (isFloat && language === 'en-US') return `(,${dString}).${dString}`;
  if (isFloat && language === 'pt-BR') return `(.${dString}),${dString}`;
  return 'd';
};

const OdometerDisplay = ({ sensor }) => {
  const { i18n } = useTranslation();

  return (
    <>
      <Odometer
        format={formatOdometer(sensor.reading, i18n.language)}
        duration={100}
        value={sensor.reading}
      />
      &nbsp;<span>{displayUnit(sensor.unit)}</span>
    </>
  );
};

OdometerDisplay.propTypes = {
  sensor: PropTypes.shape({
    id: PropTypes.string,
    position: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }),
    reading: PropTypes.number,
    unit: PropTypes.string,
  }),
};

export default OdometerDisplay;
